import { Button, Grid } from "@mui/material";
import { Form, Formik, FormikProps } from "formik";
import { useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import AuthorizeScreen from "../../../core/auth/Authorize";
import { BaseUrlParam } from "../../../core/components/BaseUrlParam";
import BaseTextField from "../../../core/components/base/BaseTextField";
import { CheckDto } from "../CheckDataType";
import { useMutationUpdateCheck, useQueryCheckById } from "../CheckQuery";
import { CheckSubTypeQueryAutocomplete } from "./CheckSubTypeAutocomplete";



const CheckEditionScreen = () => {

    let { id } = useParams<BaseUrlParam>();

    let { data: check, isLoading } = useQueryCheckById(Number(id))

    let navigate = useNavigate();
    let ref = useRef<FormikProps<CheckDto>>(null);
    let updateCheck = useMutationUpdateCheck(ref);

    const onSubmit = async (values: CheckDto) => {
        await updateCheck.mutateAsync(values);
        navigate("/ootr/checks");
    }

    if (isLoading)
        return null;




    return <AuthorizeScreen roles={["Admin"]}>
        <Formik<CheckDto>
            initialValues={check}
            onSubmit={async (values) => await onSubmit(values)}
            innerRef={ref}
        >
            {({ values, setFieldValue }) => {
                return <Form>
                    <Grid container justifyContent={"space-between"}>
                        <Grid item xs={2} />
                        <Grid item xs={4}>
                            <BaseTextField disabled value={values.name} />
                        </Grid>
                        <Grid item xs={4}>
                            <CheckSubTypeQueryAutocomplete selection={values.checkSubType} additionalOnChange={(s) => setFieldValue("checkSubType", s)} />
                        </Grid>
                        <Grid item xs={2} />
                        <Grid item container xs={12} justifyContent={"center"}>
                            <Button type="submit">Save</Button>

                        </Grid>
                    </Grid>
                </Form>
            }}
        </Formik>
    </AuthorizeScreen>
}

export default CheckEditionScreen